import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageMeta from './PageMeta';
import { useTranslation } from '../contexts/LanguageContext';
import './LegalDocument.css';

function Impressum() {
    const navigate = useNavigate();
    const { t, language } = useTranslation();
    const title = t('legal.impressum.title');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legal-document">
            <PageMeta path="/impressum" />
            <div className="legal-container">
                <button className="legal-back-btn" onClick={() => navigate('/')}>
                    <i className="fas fa-arrow-left"></i> {t('legal.backToGame')}
                </button>
                <h1>{title}</h1>
                <p className="last-updated">Information pursuant to the Croatian Electronic Commerce Act (Zakon o elektroničkoj trgovini, Art. 7) and EU E-Commerce Directive (2000/31/EC, Art. 5)</p>
                {language !== 'en' && (
                    <div className="contact-info" role="note">
                        <p>{t('legal.englishOnly')}</p>
                    </div>
                )}

                <section>
                    <h2>Company Information</h2>
                    <div className="contact-info">
                        <p><strong>Company Name:</strong> CoreDL d.o.o.</p>
                        <p><strong>Legal Form:</strong> Društvo s ograničenom odgovornošću (Limited Liability Company)</p>
                        <p><strong>Registered Address:</strong> Gajnički vidikovac II. 14/2, 10090 Zagreb, Croatia</p>
                        <p><strong>OIB (Personal Identification Number):</strong> 33905700350</p>
                        <p><strong>Court of Registration:</strong> Trgovački sud u Zagrebu (Commercial Court in Zagreb)</p>
                        <p><strong>Email:</strong> <a href="mailto:support@word-labyrinth.com">support@word-labyrinth.com</a></p>
                        <p><strong>Website:</strong> <a href="https://www.word-labyrinth.com" target="_blank" rel="noopener noreferrer">www.word-labyrinth.com</a></p>
                    </div>
                </section>

                <section>
                    <h2>VAT Information</h2>
                    <p>
                        CoreDL d.o.o. is registered for the EU One Stop Shop (OSS) scheme for cross-border
                        B2C digital services. VAT is charged based on the customer's country of residence
                        in accordance with EU VAT rules for electronically supplied services.
                    </p>
                </section>

                <section>
                    <h2>Supervisory Authority</h2>
                    <p>
                        The lead data protection supervisory authority is:
                    </p>
                    <div className="contact-info">
                        <p><strong>Agencija za zaštitu osobnih podataka (AZOP)</strong></p>
                        <p>Croatian Personal Data Protection Agency</p>
                        <p>Selska cesta 136, 10000 Zagreb, Croatia</p>
                        <p><a href="https://azop.hr" target="_blank" rel="noopener noreferrer">https://azop.hr</a></p>
                    </div>
                </section>

                <section>
                    <h2>Dispute Resolution</h2>
                    <p>
                        The European Commission provides an Online Dispute Resolution (ODR) platform
                        for consumers:{' '}
                        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                            https://ec.europa.eu/consumers/odr
                        </a>
                    </p>
                    <p>
                        We are willing but not obligated to participate in dispute resolution proceedings
                        before a consumer arbitration board. For any inquiries, please contact us
                        at <a href="mailto:support@word-labyrinth.com">support@word-labyrinth.com</a>.
                    </p>
                </section>

                <section>
                    <h2>Liability for Content</h2>
                    <p>
                        The contents of our website and application have been created with the utmost care.
                        However, we cannot guarantee the accuracy, completeness, or timeliness of the content.
                        As a service provider, we are responsible for our own content on these pages in accordance
                        with applicable law.
                    </p>
                </section>

                <section className="legal-footer">
                    <p>
                        This legal notice applies to the Word Labyrinth website (www.word-labyrinth.com)
                        and all associated mobile applications.
                    </p>
                </section>
            </div>
        </div>
    );
}

export default Impressum;
